import React from "react";
import { RooflineMark } from "./RooflineMark";
import { Reveal } from "./Reveal";

// Shared, centred section header: keeps every section symmetrical and consistent.
type SectionHeaderProps = {
  id: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "light" | "dark";
  level?: "h1" | "h2";
};
export function SectionHeader({
  id,
  title,
  intro,
  tone = "light",
  level = "h2"
}: SectionHeaderProps) {
  const Heading = level;
  const dark = tone === "dark";
  return <Reveal className="mx-auto max-w-3xl text-center" data-id="element-599" data-mp="l5lfhabggp47">
      <span className="inline-flex items-center gap-3" data-id="element-600" data-mp="l40ile1o4u36">
        <span aria-hidden="true" className={`h-px w-8 ${dark ? "bg-paper/30" : "bg-line"}`} data-id="element-601" data-mp="g5fh7baok4d5" />
        <RooflineMark className="text-ocean" data-id="element-602" data-mp="b7nseq5c0yd6" />
        <span aria-hidden="true" className={`h-px w-8 ${dark ? "bg-paper/30" : "bg-line"}`} data-id="element-603" data-mp="b8yrwdrqvjyh" />
      </span>
      <Heading id={id} className={`mt-5 text-[32px] font-semibold leading-[1.08] tracking-[-0.02em] md:text-[48px] ${dark ? "text-paper" : "text-charcoal"}`} data-id="element-604" data-mp="2ai5lmmyocvys">
        {title}
      </Heading>
      {intro && <p className={`mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed md:text-[19px] ${dark ? "text-paper/75" : "text-slate"}`} data-id="element-605" data-mp="3kq7a5zt781yo">{intro}</p>}
    </Reveal>;
}